import { ENTITY_SYNC_STATUS_SAVE } from 'constants/ActionTypes';

export function save(entity, data) {
    return (dispatch) => {
        dispatch({
            type: ENTITY_SYNC_STATUS_SAVE,
            entity: entity.entity,
            data,
        });
    };
}
